export default __webpack_public_path__ + "static/media/calendar.fbac8930.svg";